export const feedCardBackgroundColorVarKey = '--feed-card-background-color';
